import {
  isDefined,
  string2json,
  json2string,
  isFunction,
  isStringEmpty,
  logStdout
} from "../shared/utils";
import { iniReader, iniWriter } from "./iniReaderWriter";
const { exec, execSync, spawn, spawnSync } = window.require("child_process");
const fs = window.require("fs");
const { PNG } = window.require("pngjs");
const os = window.require("os");
const { stat, readdirSync } = fs;
const path = window.require("path");
const { remote } = window.require("electron");
const openTools = remote.getGlobal("openTools");
const openDevTools = remote.getGlobal("openDevTools");
const openUpdate = remote.getGlobal("openUpdate");
const openPrinterWindow = remote.getGlobal("openPrinterWindow");
const closePrinterWindow = remote.getGlobal("closePrinterWindow");
const changePage = remote.getGlobal("changePage");
const moment = window.require("moment");
let NET_CARD = "wlp2s0";
let timeoutSync;
const relaunch = remote.getGlobal("relaunch");
const register = remote.getGlobal("register");
const findUsbDriver = remote.getGlobal("findUsbDriver");
global.dialog = remote.getGlobal("dialog");
class FileSystem {
  constructor() {
    this.sysPath = remote.getGlobal("mainEnv").syspath;
    this.root = this.sysPath.root;
    this.fileSize = -1;
    let dir = this.getCfgPath();
    exec(`chmod +x /home/mw520/*.sh;chmod +x ${this.getUtilPath()}/*`, () => {});
    if (!this.isFileExists(dir)) {
      this.mkdir(this.getCfgPath());
    }
    dir = this.getTopographyCfgPath();
    if (!this.isFileExists(dir)) {
      this.mkdir(dir);
    }
    dir = this.getCasePath();
    if (!this.isFileExists(dir)) {
      this.mkdirSync(dir);
    }
    dir = this.getCalibPath();
    if (!this.isFileExists(dir)) {
      this.mkdir(dir);
    }
    NET_CARD = this.detectWirelessCard();
  }

  getSN() {
    try {
      const data = fs.readFileSync(this.getCalibPath("device.json"));
      return JSON.parse(data.toString()).SN;
    } catch (error) {
      console.log("---sn111--- error", error);
      return undefined;
    }
  }

  detectWirelessCard() {
    let wlcName = "wlp2s0";
    try {
      wlcName = execSync(`/home/mw520/wireless_card.sh`).toString().trim();
    } catch (e) {
      logStdout("wireless card error", e.message);
    }
    return wlcName;
  }
  combinePath() {
    try {
      return path.join(...arguments);
    } catch (e) {
      return null;
    }
  }
  bmpData2Png(bpmdata, width, height, dstpath, callback) {
    if (!isDefined(bpmdata)) {
      logStdout("bmpData2Png error", "data is null");
      callback(new Error("bmp data error"));
      return;
    }
    let png = new PNG({ width, height });
    png.data = bpmdata;
    png
      .pack()
      .pipe(fs.createWriteStream(dstpath))
      .on("finish", () => {
        logStdout("bmpData2Png finish", dstpath);
      })
      .on("error", (error) => {
        callback(error);
        logStdout("bmpData2Png error", error.message);
      })
      .on("close", () => {
        if (callback) callback();
        logStdout("bmpData2Png closed");
      });
  }
  relaunch() {
    relaunch();
  }
  umountUsbDriver(driver, callback) {
    if (!driver) {
      if (callback) callback();
      return;
    }
    const { partion, location } = driver;
    exec(`umount ${partion}`, (err) => {
      if (err) {
        logStdout("umount usb driver", err.message || "");
        exec(`umount ${location}`, (err) => {
          if (err) logStdout("umount usb driver", err.message || "");
          if (callback) callback();
        });
      } else {
        if (callback) callback();
      }
    });
  }
  mkdirSync(dir) {
    try {
      logStdout("mkdir dir", dir);
      if (!this.isFileExists(dir)) {
        fs.mkdirSync(dir, { recursive: true });
        return true;
      } else {
        return true;
      }
    } catch (e) {
      logStdout("mkdir error", e.message);
      return false;
    }
  }
  findUsbDriver() {
    if (window.__main__.debug) {
      return {
        status: true,
        location: "D:\\",
        used: 10240,
        capacity: 1024 * 1024
      };
    }
    return findUsbDriver();
  }
  getElectronMem(callback) {
    let cmd = `ps aux | grep electron | grep '\\-\\-type=renderer' | awk -F ' ' '{print $6}'`;
    // 5G
    // 1024000 = 1G
    exec(cmd, (err, stdout) => {
      if (err) {
        console.log(err);
        if (callback) callback(err);
      } else {
        let result = stdout.toString().trim();
        if (callback) callback(null, parseInt(result));
      }
    });
  }
  getFreeMem(callback) {
    exec(`free | grep 'Mem:' | awk -F ' ' '{print $4}'`, (err, stdout) => {
      // 2G
      if (err) {
        console.log(err);
        callback(err);
      } else {
        let result = stdout.toString().trim();
        callback(null, parseInt(result));
      }
    });
  }
  mkdir(dir, callback) {
    try {
      if (!this.isFileExists(dir)) {
        fs.mkdir(dir, (err) => {
          this.syncDisk();
          if (isFunction(callback)) {
            callback(err);
          }
        });
      }
    } catch (e) {}
  }

  setHeadphonesMode(callback) {
    logStdout("set set-sink-port start");
    exec("pactl set-sink-port 0 analog-output-headphones", (err) => {
      logStdout("set headphones end", (err || { message: "no error" }).message);
      if (callback) callback();
    });
  }
  muteSound(val, callback) {
    logStdout("set set-sink-mute start", val);
    exec(`pactl set-sink-mute 0 ${val}`, (err) => {
      logStdout("set set-sink-mute end", (err || { message: "no error" }).message);
      if (callback) callback();
    });
  }
  setSound(val, callback) {
    logStdout("set set-sink-volume start", val);
    exec(`pactl set-sink-volume 0 ${parseInt(val)}%`, (err) => {
      logStdout("set set-sink-volume end", (err || { message: "no error" }).message);
      if (callback) callback();
    });
  }
  playTTS(soundPath, callback) {
    logStdout("aplay start", soundPath);
    exec("killall aplay", () => {
      exec(`aplay ${soundPath}`, () => {
        logStdout("aplay end", soundPath);
        if (callback) callback();
      });
    });
  }
  stopTTS(callback) {
    exec("killall aplay", () => {
      if (callback) callback();
    });
  }
  normalExportName(folderName, patient, record, osod, langcfg) {
    let dst = [];
    for (let id in folderName) {
      switch (folderName[id]) {
        case "name":
          if (window.printSettings.general.anonymous.patientinfo) {
            let val = `${patient.firstname}${
              patient.lastname && patient.lastname !== "" ? " " + patient.lastname : ""
            }`.trim();
            dst.push(val);
          }
          break;
        case "pid":
          if (window.printSettings.general.anonymous.patientinfo) {
            dst.push(patient.pid);
          }
          break;
        case "checktype":
          if (record) {
            let val = `${
              record.checktype === "dryeye" ? langcfg.txtDryEye : langcfg.txtTopography
            }`;
            dst.push(val);
          }
          break;
        case "eye":
          if (osod) dst.push(osod);
          break;
        case "checktime":
          if (record) dst.push(moment(record.recorddate).format("YYYYMMDD_HHmmss"));
          break;
        default:
          break;
      }
    }
    return dst.join("_");
  }
  isLogined() {
    let loginInfo;
    const pwdPath = this.getTmpFilePath("passwd.json");
    if (fileSys.isFileExists(pwdPath)) {
      loginInfo = fileSys.readJsonFile(pwdPath);
    }
    return loginInfo;
  }
  copyOneFileByPipe(src, dst, callback) {
    let iscalled = false;
    if (this.isFileExists(src)) {
      const srcst = fs.createReadStream(src);
      const dstst = fs.createWriteStream(dst);
      srcst.pipe(dstst);
      dstst.on("close", () => {
        if (!iscalled) {
          logStdout("export finish");
          iscalled = true;
          if (callback) callback();
        }
      });
      srcst.on("error", (err) => {
        logStdout("export src error", err.message || "");
        if (!iscalled) {
          iscalled = true;
          if (callback) callback(err);
        }
      });
      dstst.on("error", (err) => {
        logStdout("export dst stream error", err.message || "");
        if (!iscalled) {
          iscalled = true;
          if (callback) callback(err);
        }
      });
    } else {
      logStdout("export: src not exists");
      if (!iscalled) {
        iscalled = true;
        if (callback) callback(new Error("no src file"));
      }
    }
  }
  getDatabasePath() {}
  getFileBaseName(filepath) {
    return path.basename(filepath);
  }
  getTmpFilePath(file) {
    return isDefined(file) ? this.combinePath("/run/user/1000", file) : "/run/user/1000";
  }
  getDicomTmpFilePath(file) {
    let dicomPath = "/tmp/dicom";
    this.mkdirSync(dicomPath);
    return isDefined(file) ? this.combinePath(dicomPath, file) : dicomPath;
  }
  getFullPath(path1, path2) {
    return this.combinePath(path1, path2);
  }
  getUtilPath(file) {
    return isDefined(file) ? this.combinePath(this.sysPath["utils"], file) : this.sysPath["utils"];
  }
  getCfgPath(file) {
    return isDefined(file)
      ? this.combinePath(this.sysPath["config"], file)
      : this.sysPath["config"];
  }
  getQuestionnaireFilePathCN(file) {
    let cfgPath = this.getCfgPath();
    return isDefined(file)
      ? this.combinePath(cfgPath, "dryeyeReport/questionnaireReport/CNPage", file)
      : this.combinePath(cfgPath, cfgPath);
  }
  getQuestionnaireFilePathEN(file) {
    let cfgPath = this.getCfgPath();
    return isDefined(file)
      ? this.combinePath(cfgPath, "dryeyeReport/questionnaireReport/ENPage", file)
      : this.combinePath(cfgPath, cfgPath);
  }
  getTopoGrahyReportFilePath(file, bino) {
    let cfgPath = this.getCfgPath();
    let ejsPath = isDefined(bino) ? `topographyReport_${bino}` : "topographyReport";
    return isDefined(file)
      ? this.combinePath(cfgPath, ejsPath, file)
      : this.combinePath(cfgPath, cfgPath);
  }
  getTopgraphyReportMinoFilePath(file) {
    let cfgPath = this.getCfgPath();
    return isDefined(file)
      ? this.combinePath(cfgPath, "topographyReport_mino", file)
      : this.combinePath(cfgPath, cfgPath);
  }
  getUploadPath(file) {
    return isDefined(file)
      ? this.combinePath(this.sysPath["server"], "uploads", file)
      : this.sysPath["server"];
  }
  getMediaPath(file) {
    return isDefined(file) ? this.combinePath(this.sysPath["media"], file) : this.sysPath["media"];
  }
  getOctDataPath(file) {
    let octdataPath = this.getMediaPath("octdata");
    if (!this.isFileExists(octdataPath)) {
      this.mkdirSync(octdataPath);
    }
    return isDefined(file) ? this.combinePath(octdataPath, file) : octdataPath;
  }
  getTopographyCfgPath(file) {
    return isDefined(file)
      ? this.combinePath(this.getCfgPath("topograpy"), file)
      : this.getCfgPath("topograpy");
  }
  getCalibPath(file) {
    return isDefined(file)
      ? this.combinePath(this.root, "calib", file)
      : this.combinePath(this.root, "calib");
  }
  getLanguagePath(file) {
    return this.combinePath(this.getCfgPath("i18n"), file);
  }
  getCasePath(file) {
    return isDefined(file)
      ? this.combinePath(this.root, "cases", file)
      : this.combinePath(this.root, "cases");
  }
  getMockPath(file) {
    return isDefined(file) ? this.combinePath(this.sysPath["mock"], file) : this.sysPath["mock"];
  }
  getStaticImagePath(file) {
    return isDefined(file)
      ? this.combinePath(this.getCfgPath(), "img", file)
      : this.combinePath(this.getCfgPath(), "img");
  }

  getAudioPath(file) {
    const { language } = window.settings;
    let currentLanguage = language === "zh_CN" ? "zh_CN" : "en_US";
    return isDefined(file)
      ? this.combinePath(this.getCfgPath(), "audio", currentLanguage, file)
      : this.combinePath(this.getCfgPath(), "audio");
  }
  renameFile(dir, oldname, newname) {
    let oldpath = this.combinePath(dir, oldname);
    let newpath = this.combinePath(dir, newname);
    if (this.isFileExists(dir)) {
      fs.renameSync(oldpath, newpath);
    }
  }
  renameFileFullpath(oldpath, newpath) {
    try {
      if (this.isFileExists(oldpath)) {
        fs.renameSync(oldpath, newpath);
        return true;
      }
    } catch (e) {
      return false;
    }
  }
  readFile(filepath, encoding = "utf-8", flag = false) {
    try {
      if (flag === true) {
        return fs.readFileSync(filepath);
      } else {
        return fs.readFileSync(filepath, encoding);
      }
    } catch (e) {
      logStdout("read file failed", e.message || "");
      return null;
    }
  }
  changePage() {
    this.saveJsonFile(this.getTmpFilePath("passwd.json"), {
      password: window.localStorage.getItem("login-password") || "",
      username: window.session.user.username
    });
    this.clearCache();
    changePage();
  }
  clearCache(callback) {
    exec("echo 3 > /proc/sys/vm/drop_caches", () => {
      if (callback) callback();
    });
  }
  getFileExternName(filepath) {
    return path.extname(filepath);
  }
  convertPDF2Image(pdfPath, imagePath, options = { singlepage: true }, callback) {
    const extname = path.extname(imagePath);
    const dir = path.dirname(imagePath);
    let basename = path.basename(imagePath);
    let filepath = options.singlepage
      ? imagePath
      : path.join(dir, `${basename.replace(extname, "")}-%02d${extname}`);
    const param = options.singlepage ? "-append" : "+adjoin";
    const cmd = `${fileSys.getUtilPath(
      "gm"
    )} convert -density 220 -quality 50 "${pdfPath}" ${param} "${filepath}"`;
    logStdout("dicom-convert pdf to image", cmd);
    exec(cmd, (error) => {
      if (error) logStdout("dicom-convert pdf to image error", error.message);
      if (callback) callback(error);
    });
  }
  readDirectory(parentDir) {
    try {
      let fullpaths = [];
      let dirs = readdirSync(parentDir);
      dirs.map((d) => {
        fullpaths.push(path.join(parentDir, d));
      });
      return fullpaths;
    } catch (e) {
      return [];
    }
  }
  readJsonFile(filepath) {
    return string2json(this.readFile(filepath));
  }
  writeFileSync(filepath, content, encoding = "utf-8") {
    try {
      fs.writeFileSync(filepath, content, encoding);
      this.sync();
    } catch (e) {
      console.log(e.message);
    }
  }
  writeFile(filepath, content, callback) {
    fs.writeFile(filepath, content, (err) => {
      this.sync();
      if (isFunction(callback)) {
        callback(err);
      }
    });
  }
  saveJsonFile(filepath, obj) {
    this.writeFileSync(filepath, json2string(obj));
  }
  isFileExists(filepath) {
    return fs.existsSync(filepath);
  }
  deleteFile(filepath) {
    try {
      if (fs.existsSync(filepath)) {
        fs.unlinkSync(filepath);
      }
      this.syncDisk();
      return true;
    } catch (e) {
      console.log(`remove file failed: ${e}`);
      return false;
    }
  }
  sync() {
    try {
      execSync(`sync;sync`);
    } catch (e) {}
  }
  killallExe(exe) {
    try {
      execSync(`killall ${exe};pkill -9 ${exe}`);
    } catch (e) {}
  }
  mountSharedFS(cmds, callback) {
    let params = cmds;
    logStdout("mount shared folder params", params);
    let shellPath = this.getUtilPath(`mount_sharedfs.sh`);
    let sp = spawn(shellPath);
    let _error = "";
    sp.on("error", (error) => {
      if (error) logStdout("umount shared folder stdout", error.message);
      if (callback) {
        callback(error);
      }
    });
    sp.stdout.on("data", (data) => {
      logStdout("umount stdout", data.toString());
    });
    sp.stderr.on("data", (data) => {
      _error = data.toString();
      logStdout("umount stderr", data.toString());
    });
    sp.on("close", (code) => {
      if (code === 0) {
        let spmount = spawn(shellPath, params);
        spmount.on("error", (err) => {
          logStdout("mount error", err.message);
          callback(err);
        });
        spmount.stdout.on("data", (data) => {
          logStdout("mount shared folder stdout", data.toString());
        });
        spmount.stderr.on("data", (data) => {
          _error = data.toString();
          logStdout("mount shared folder stderr", data.toString());
        });
        spmount.on("close", (code) => {
          if (code === 0) {
            callback();
          } else {
            callback(new Error(_error || ""));
          }
        });
      } else {
        logStdout("umount result", code);
        callback(new Error(_error || ""));
      }
    });
  }
  umountSharedFS(callback) {
    exec(this.getUtilPath("mount_sharedfs.sh"), (err, stdout) => {
      if (err) {
        if (callback) callback(err);
      } else {
        callback();
      }
    });
  }
  clearAllFiles(dir, types, callback) {
    let filetypes = "";
    let len = types.length;
    if (len <= 0) {
      callback();
    }
    for (let id = 0; id < len; id++) {
      filetypes += ` ${dir}/*${types[id]}`;
    }
    if (filetypes !== "" && filetypes !== "/") {
      exec(`rm -rf${filetypes}`, (err) => {
        this.syncDisk();
        if (isDefined(callback)) callback(err);
      });
    } else {
      if (isDefined(callback)) callback();
    }
  }

  readIniFile(filepath) {
    return iniReader(filepath);
  }
  writeIniFile(filepath, obj) {
    let res = iniWriter(filepath, obj);
    this.sync();
    return res;
  }
  copyFile(src, dst) {
    try {
      if (!this.isFileExists(src)) {
        return false;
      }
      this.deleteFile(dst);
      try {
        fs.copyFileSync(src, dst);
        this.syncDisk();
      } catch (e) {
        console.log(e);
        return false;
      }
    } catch (e) {
      console.log(e);
      return false;
    }
  }
  syncDisk() {
    clearTimeout(timeoutSync);
    timeoutSync = setTimeout(() => {
      exec("sync", () => {});
    }, 1000);
  }
  syncImmediate(callback) {
    exec("sync", () => {
      if (callback) callback();
    });
  }
  getLanConfig() {
    let interfaces = os.networkInterfaces();
    let ipAddress = [];
    for (let id in interfaces) {
      if (
        id.toLocaleLowerCase().indexOf("enx") >= 0 ||
        id.toLocaleLowerCase().indexOf("eno") >= 0
      ) {
        if (isDefined(interfaces[id][0])) {
          let obj = interfaces[id][0];
          obj.port = id;
          if (obj.address !== "172.18.3.10") {
            ipAddress.push(obj);
          }
        }
      }
    }
    return ipAddress;
  }

  getFirstEnxNet() {
    return new Promise((resolve, reject) => {
      exec("ifconfig", (err, data) => {
        if (err) {
          console.log("---net231 getFirstEnxNet err---", err);
          resolve(undefined);
        } else {
          const str = data.toString();
          let arr = str.toString().split("\n");
          for (let i = 0; i < arr.length; i++) {
            if (arr[i].includes("enx")) {
              resolve(arr[i].split(":")[0].trim());
              return;
            }
          }
          resolve(undefined);
        }
      });
    });
  }

  async getRouterIp() {
    return new Promise(async (resolve, reject) => {
      exec("ifconfig", (err, data) => {
        if (err) {
          resolve(undefined);
        } else {
          const str = data.toString();
          let arr = str.toString().split("\n");
          for (let i = 0; i < arr.length; i++) {
            if (arr[i].includes("enx")) {
              resolve(arr[i + 1].trim().split(" ")[1]);
              return;
            }
          }
          resolve(undefined);
        }
      });
    });
  }

  selectRouterAndDhcpMode(mode) {
    return new Promise(async (resolve, reject) => {
      const EnxNet = await this.getFirstEnxNet();
      if (!EnxNet) {
        reject("未找到有线网口");
        return;
      }
      exec(`nmcli -g CONNECTIONS.AVAILABLE-CONNECTIONS device show ${EnxNet}`, (err0, data0) => {
        if (err0) {
          reject("获取uuid失败");
        } else {
          const uuid = data0.toString().trim().split("|")[0];
          if (mode === "dhcp") {
            exec(
              `echo ' ' | sudo -S ifconfig ${EnxNet} 0.0.0.0;
              echo ' ' | sudo -S nmcli connection modify uuid ${uuid} ipv4.method auto ipv4.address 0.0.0.0;
              echo ' ' | sudo -S nmcli device modify ${EnxNet} ipv4.method auto ipv4.address 0.0.0.0`,
              (err2, data2) => {
                if (err2) {
                  reject("设置dhcp模式失败");
                } else {
                  resolve("OK");
                }
              }
            );
          } else {
            exec(
              `echo ' ' | sudo -S nmcli connection modify uuid ${uuid} ipv4.method shared ipv4.addresses 172.18.3.10/24;
              echo ' ' | sudo -S nmcli device modify ${EnxNet} ipv4.method shared ipv4.addresses 172.18.3.10/24`,
              (err1, data1) => {
                if (err1) {
                  // reject("设置路由器模式失败");
                  exec(
                    `echo ' ' | sudo -S nmcli connection modify uuid ${uuid} ipv4.method shared ipv4.addresses 172.18.3.10/24 -ipv4.dns 0;
                    echo ' ' | sudo -S nmcli device modify ${EnxNet} ipv4.method shared ipv4.addresses 172.18.3.10/24 -ipv4.dns 0`,
                    (err1, data1) => {
                      if (err1) {
                        reject("设置路由器模式失败");
                      } else {
                        resolve("OK");
                      }
                    }
                  );
                } else {
                  resolve("OK");
                }
              }
            );
          }
        }
      });
    });
  }

  selectDhcpMode() {}

  getWifiConfig(nc) {
    const netcard = nc || NET_CARD;
    let interfaces = os.networkInterfaces();
    let netConfig = interfaces[netcard];
    if (isDefined(netConfig)) {
      let config = netConfig[0];
      if (isDefined(config)) {
        config.netCardName = netcard;
        return config;
      } else {
        return null;
      }
    } else {
      return null;
    }
  }
  register(cbName, callback) {
    register(cbName, callback);
  }
  getFileSizeSync(filePath) {
    if (this.isFileExists(filePath)) {
      return fs.statSync(filePath).size;
    } else {
      return -1;
    }
  }
  getFileSize(filepath, callback) {
    fs.stat(filepath, (err, st) => {
      if (!isDefined(err)) {
        if (isFunction(callback)) {
          callback(st.size);
        }
      } else {
        callback();
      }
    });
  }
  isFileWriteFinished(filepath, callback, size = 0) {
    if (this.fileSize === size) {
      if (isFunction(callback)) {
        this.fileSize = -1;
        callback();
      }
    } else {
      this.fileSize = size;
      setTimeout(() => {
        this.getFileSize(filepath, (size) => {
          if (isDefined(size)) {
            this.isFileWriteFinished(filepath, callback, size);
          } else {
            this.fileSize = -1;
            if (isFunction(callback)) {
              callback(new Error("error"));
            }
          }
        });
      }, 100);
    }
  }
  isLinux() {
    return os.platform() === "linux";
  }
  isWindow() {
    return os.platform() === "win32";
  }
  isDarwin() {
    return os.platform() === "darwin";
  }
  getFreeSpace(storagepath, callback) {
    if (this.isWindow()) {
      this.getFreeSpaceWin(storagepath, callback);
    } else {
      let volumesize = this.GetDiskUsage();
      let percent = this.GetDiskUsagePercent();
      callback(volumesize, percent);
    }
  }
  GetDiskUsage(fsys) {
    var pos = fsys || "/dev/sda6";
    var cmd = "df -h /dev/sd* | grep -w " + pos + " | awk -F ' ' '{print $3\"/\"$2}'";
    try {
      var ret = execSync(cmd);
      ret = ret.toString().trim();
      return ret;
    } catch (e) {
      return "";
    }
  }
  isThirdPartyEnabled() {
    return (
      window.thirdPartySettings &&
      window.thirdPartySettings.auto &&
      window.thirdPartySettings.auto.value &&
      window.thirdpartyScript
    );
  }
  GetDiskUsagePercent(fsys) {
    try {
      var pos = fsys || "/dev/sda6";
      var cmd = "df -h /dev/sd* | grep -w " + pos + " | awk -F ' ' '{print $5}' | cut -d \"%\" -f1";
      var ret = execSync(cmd);
      ret = ret.toString().trim();
      return parseInt(ret);
    } catch (e) {
      return -1;
    }
  }
  isUDiskExits(driver) {
    if (window.__main__.debug) {
      return {
        status: true,
        location: this.isDarwin() ? "/tmp" : "D:\\",
        used: 10240,
        capacity: 1024 * 1024
      };
    }
    const usbDriver = driver || window.usbDriver;
    if (isDefined(usbDriver) && isDefined(usbDriver.location) && usbDriver.location !== "") {
      return { status: true, ...usbDriver };
    } else {
      return { status: false };
    }
  }
  getUDiskInfo(callback) {
    const KEYS = {
      partition: false,
      capacity: true,
      used: true,
      available: true,
      usedPercent: false,
      location: false
    };
    const { status, location } = this.isUDiskExits();
    let result = { status };
    if (status) {
      const cmd = `df | grep ${location} | awk -F ' ' '{print $1 " " $2 " " $3 " " $4 " " $5 " " $6}'`;
      exec(cmd, (err, data) => {
        if (err) {
          result.status = false;
          if (callback) callback(result);
        } else {
          let arr = data.toString().trim().split(" ");
          Object.keys(KEYS).forEach((key, index, o) => {
            result[key] = KEYS[key] ? parseInt(arr[index]) : arr[index];
          });
          if (callback) callback(result);
        }
      });
    } else {
      if (callback) callback(result);
    }
  }
  capacityConverter(val) {
    const result = {
      value: 0,
      unit: "G"
    };
    let value = Math.round(val / 1024.0 / 1024.0);
    if (value >= 1) {
      result.unit = "G";
    } else {
      value = Math.round(val / 1024.0);
      if (value >= 1) {
        result.unit = "M";
      } else {
        value = 0;
        result.unit = "M";
      }
    }
    result.value = value;
    return result;
  }
  getFreeSpaceWin(storagepath, callback) {
    var _path = storagepath;
    if (storagepath[0] === ".") {
      _path = process.cwd();
    }
    if (_path[1] === ":") {
      exec(
        "wmic LogicalDisk where \"Caption='" +
          path.substring(0, 2) +
          "'\" get FreeSpace,Size /value",
        function (error, stdout, stderr) {
          if (error) throw new Error(error);
          var vals = stdout.split("\n");
          var freespace = 0;
          var volumesize = 0;
          for (var id in vals) {
            var line = vals[id];
            if (line.indexOf("FreeSpace") >= 0) {
              freespace = parseInt(line.substring(10, line.indexOf("\r")));
            }
            if (line.indexOf("Size") >= 0) {
              volumesize = parseInt(line.substring(5, line.indexOf("\r")));
            }
          }
          if (callback !== null && typeof callback === "function") {
            callback(freespace, volumesize);
          }
        }
      );
    } else {
      let freespace = 10;
      let volumesize = "1G / 1T";
      callback(volumesize, freespace);
    }
  }
  openTools() {
    openTools();
  }
  openDevTools() {
    openDevTools();
  }
  openUpdate(lang) {
    openUpdate(lang);
  }
  openPrinterWindow(lang) {
    openPrinterWindow(lang);
  }
  closePrinterWindow(lang) {
    closePrinterWindow(lang);
  }
  checkCamera(callback) {
    let sp = window.__capture__.debug
      ? spawn(this.getUtilPath("camtest.bat"))
      : spawn(this.getUtilPath("camtest.sh"));
    sp.on("exit", (code) => {
      if (isFunction(callback)) {
        code = !code;
        callback(code);
      }
    });
  }
  nautilus(dir) {
    exec("kill -9 nautilus", () => {
      const sp = spawn("nautilus", [dir], { detached: true });
      sp.on("error", (err) => console.log(err));
      sp.stdout.on("data", (data) => console.log(data.toString()));
      sp.stderr.on("data", (data) => console.log(data.toString()));
    });
  }
  powerOff() {
    setTimeout(() => {
      exec("sync", () => {
        exec(`poweroff`, (error) => {
          console.log(error);
        });
      });
    }, 500);
  }
  // 复制目录
  copyFileToFile(src, dst, callback) {
    try {
      if (!this.isFileExists(src)) {
        return false;
      }
      try {
        this.readDir(src, dst, null, callback);
      } catch (e) {
        console.log(e);
        return false;
      }
    } catch (e) {
      console.log(e);
      return false;
    }
  }
  // 读取目录
  readDir(src, dst, kid, callback) {
    let flag;
    fs.readdir(src, (err, paths) => {
      if (err) {
        flag = -1;
        callback(flag);
        throw err;
      } else {
        paths.forEach(function (path) {
          let srcKid;
          // =1 是指有子文件夹
          if (kid === 1) {
            srcKid = src + "/" + path;
          } else {
            srcKid = src + path;
          }
          let dstKid = dst + "/" + path;
          let readable;
          let writable;
          stat(srcKid, function (err, st) {
            if (err) {
              flag = -1;
              callback(flag);
              throw err;
            }
            if (st.isFile()) {
              readable = fs.createReadStream(srcKid);
              writable = fs.createWriteStream(dstKid);
              readable.pipe(writable);
              flag = 0;
              callback(flag);
            } else if (st.isDirectory()) {
              fs.mkdir(dstKid, function () {
                const srcKid2 = srcKid;
                const dstKid2 = dstKid;
                fileSys.readDir(srcKid2, dstKid2, 1, callback);
              });
            }
          });
        });
      }
    });
  }

  getSystemVersion() {
    if (window.__main__.debug) {
      return "kernel-2.6.23.9-85.fc8";
    }
    return this.readFile("/home/mw520/system/version");
  }
  getUUID(callback) {
    if (window.__main__.debug && isFunction(callback)) {
      window.uid = "xxxxx-xxx-xxx-xxx-xxxx";
      callback(window.uid);
      return;
    }
    let uuidPath = this.getCfgPath("uuid");
    let uuid = this.readFile(uuidPath);
    if (isDefined(uuid) && !isStringEmpty(uuid)) {
      window.uid = uuid || "";
      window.uid = window.uid.trim();
      if (isFunction(callback)) callback(uuid);
    } else {
      exec(
        `blkid | grep /dev/sda1 | awk -F ' ' '{ print $2 }' | cut -d "%" -f1 |cut -d "=" -f2`,
        (err, data) => {
          if (!isDefined(err)) {
            uuid = data.toString().replace(/\"/g, "");
            window.uid = uuid.trim();
            this.writeFileSync(this.getCfgPath("uuid"), uuid.trim());
            if (isFunction(callback)) callback(uuid);
          } else {
            if (isFunction(callback)) callback();
          }
        }
      );
    }
  }
  delWirelessRoute(callback) {
    const cmdWirelessCard = `ifconfig| grep wlp[0-9] | awk -F ' ' '{print $1}' | cut -d ':' -f1`;
    exec(cmdWirelessCard, (err, data) => {
      const wireless = data.toString().trim();
      if (!err && !isStringEmpty(wireless)) {
        const cmdRouteGW = `route -n | grep  "${wireless}" | grep "UG" | awk -F ' ' '{print $2}'`;
        exec(cmdRouteGW, (err, data) => {
          const gw = data.toString().trim();
          if (!err && !isStringEmpty(gw)) {
            const delDefaultRoute = `route del default gw ${gw}`;
            exec(delDefaultRoute, (err) => {
              if (callback) callback(err);
            });
          } else {
            if (callback) callback(err);
          }
        });
      } else {
        if (callback) callback(err);
      }
    });
  }
  // 获得所有时区
  getTimezones(callback) {
    exec("timedatectl list-timezones", function (err, data) {
      if (err && callback) callback(err);
      else {
        let arrArea = data.toString().split(/\s+/);
        let objArea = {};
        for (let id in arrArea) {
          if (arrArea[id] === "" || arrArea[id] === "UTC") continue;
          let arrCities = arrArea[id].split("/");
          objArea[arrCities[0]] = objArea[arrCities[0]] || {
            value: arrCities[0],
            label: arrCities[0],
            cities: []
          };
          if (arrCities.slice(1) === "") continue;
          objArea[arrCities[0]].cities.push({
            value: arrCities.slice(1).join("/"),
            label: arrCities.slice(1).join("_")
          });
        }
        callback(err, objArea);
      }
    });
  }
  // 获取当前地区
  getNowTimeZone(callback) {
    exec("timedatectl status | grep Time", function (err, data) {
      if (!err) {
        console.log("--", data);
        let endStr = "";
        endStr = data.split(":")[1].split(" ")[1];
        callback(endStr);
      } else {
        console.log("timedatectl-ERR", err);
      }
    });
  }
  // 修改时区
  setTimezone(timezone, callback) {
    const cmd = `timedatectl set-timezone "${timezone}" && sync`;
    exec(cmd, (err) => {
      callback(err);
    });
  }
  // 修改时间
  setDatetime(datetime, callback) {
    const cmd = `date -s "${datetime}"`;
    exec(cmd, (err) => {
      if (err) logStdout("set-date-time error", err.message || "");
      if (callback) callback(err);
    });
  }
  LipidGetOfflineReportImg(videoPath, reportImgPath) {
    return new Promise((resolve, reject) => {
      const Path = `${fileSys.getUtilPath("lipidcrop520")} ${videoPath} ${reportImgPath} `;
      exec(Path, (err, data) => {
        resolve(data);
      });
    });
  }
  cutVideoByTime(orignalPath, time, callback) {
    let newPath = orignalPath;
    if (orignalPath.indexOf("_tmp") > -1) {
      newPath = orignalPath.replace("_tmp", "");
      const cmd = `${this.getUtilPath(
        "ffmpeg"
      )} -i ${orignalPath} -vcodec copy -acodec copy -ss 00:00:00 -to 00:${time} ${newPath} -y`;
      exec(cmd, (err) => {
        this.sync();
        if (err) {
          logStdout("cutVideoByTime error", err.message || "");
          this.deleteFile(newPath);
          this.renameFileFullpath(orignalPath, newPath);
          if (callback) callback();
        } else {
          if (callback) callback();
        }
      });
    } else {
      if (callback) callback();
    }
  }
  startJapaneseKeyboard() {
    // exec("echo ' ' | sudo -S onboard -s 1920x615 -x 0", err => {
    //   console.log('onboard--------------------err:', err);
    // })
  }
  toggleInputMethod(inputMethod) {
    exec(`sudo fcitx-remote -s ${inputMethod}`, (error, stdout, stderr) => {
      if (error) {
        console.error(`执行命令时发生错误: ${error.message}`);
        return;
      }
      if (stderr) {
        console.error(`错误输出: ${stderr}`);
        return;
      }
      console.log(`切换输入法成功: ${stdout}`);
    });
  }

  // getUIGetDynamicPupilDiameters(filePath, pixelsize, callback) {
  //   logStdout('----------------time------------')
  //   let sp = spawn('node', ['/home/mw520/dea520/dist/test.js', `/home/mw520/20240428_151131_OD.mp4`, `${pixelsize}`], {
  //     detached: true
  //   })
  //   let _error = ''
  //   sp.on('error', (error) => {

  //   })
  //   sp.stdout.on('data', data => {
  //     logStdout('umount stdout', data.toString())
  //   })
  //   sp.stderr.on('data', data => {
  //     // _error = data.toString()
  //     logStdout('umount stderr', data.toString())
  //   })
  //   sp.on('close', code => {
  //     logStdout('----------------time--end------------')
  //     if (code === 0) {
  //       if (callback) callback()
  //     } else {
  //       logStdout('umount result', code)
  //       if (callback) callback({ result: false })
  //     }
  //   })
  // }
  getUIGetDynamicPupilDiameters(filePath, pixelsize, callback) {
    logStdout("----------------time------------");
    exec(
      `node /home/mw520/dea520/dist/calDynamicPupil.js ${filePath} ${pixelsize}`,
      (err, data) => {
        logStdout("--------------end----------------");
        if (err) {
          console.log("err======:", err);
          callback({ result: false, error: err });
        } else {
          let startIndex = data.indexOf("data:");
          if (startIndex !== -1) {
            let dataString = data.substring(startIndex + "data:".length);
            let res = JSON.parse(JSON.stringify(dataString));
            let newRes = JSON.parse(res);
            callback(newRes);
          } else {
            callback({ result: false });
            console.error("未找到输出的对象");
          }
        }
      }
    );
  }
  screenShot() {
    exec("echo ' ' | sudo -S gnome-screenshot -w", (err, data) => {
      if (err) console.log("screenShot---->error", err);
    });
  }

  copyFile123(path1, path2) {
    exec(`echo ' ' | sudo -S cp ${path1} ${path2}`);
  }

  removeFile123(path) {
    exec(`echo ' ' | sudo -S rm -rf ${path}`);
  }
}
const fileSys = new FileSystem();
export default fileSys;
fileSys.getUUID(() => {});



// WEBPACK FOOTER //
// ./src/fileoprators/fileSystem.js